/**
 * 天子令 - 终极科技
 * 严格按照 docs/TECH_TREE_DESIGN.md 设计
 * 需要任意4个第五层科技才能研究
 */

import type { Tech } from '../TechTypes';

export const ULTIMATE_TECH: Tech = {
  id: 'ULTIMATE',
  name: '天子令',
  description: '游戏终极目标：可宣布天下一统。需要任意4个第五层科技。',
  branch: 'ultimate',
  tier: 5,
  cost: 1500,
  researchTime: 8,
  prerequisites: [],
  // 需要任意4个第五层科技组合
  alternativePrereqs: [
    // 兵法 + 百工 + 农耕 + 商道
    ['B041', 'G041', 'N041', 'S041'],
    ['B041', 'G041', 'N041', 'S042'],
    ['B041', 'G041', 'N042', 'S041'],
    ['B041', 'G041', 'N042', 'S042'],
    ['B041', 'G042', 'N041', 'S041'],
    ['B041', 'G042', 'N041', 'S042'],
    ['B041', 'G042', 'N042', 'S041'],
    ['B041', 'G042', 'N042', 'S042'],
    ['B042', 'G041', 'N041', 'S041'],
    ['B042', 'G041', 'N041', 'S042'],
    ['B042', 'G041', 'N042', 'S041'],
    ['B042', 'G041', 'N042', 'S042'],
    ['B042', 'G042', 'N041', 'S041'],
    ['B042', 'G042', 'N041', 'S042'],
    ['B042', 'G042', 'N042', 'S041'],
    ['B042', 'G042', 'N042', 'S042'],
    // 兵法 + 百工 + 墨学 + 阴阳
    ['B041', 'G041', 'M041', 'Y041'],
    ['B041', 'G041', 'M041', 'Y042'],
    ['B041', 'G041', 'M042', 'Y041'],
    ['B041', 'G041', 'M042', 'Y042'],
    ['B041', 'G042', 'M041', 'Y041'],
    ['B041', 'G042', 'M041', 'Y042'],
    ['B041', 'G042', 'M042', 'Y041'],
    ['B041', 'G042', 'M042', 'Y042'],
    ['B042', 'G041', 'M041', 'Y041'],
    ['B042', 'G041', 'M041', 'Y042'],
    ['B042', 'G041', 'M042', 'Y041'],
    ['B042', 'G041', 'M042', 'Y042'],
    ['B042', 'G042', 'M041', 'Y041'],
    ['B042', 'G042', 'M041', 'Y042'],
    ['B042', 'G042', 'M042', 'Y041'],
    ['B042', 'G042', 'M042', 'Y042'],
    // 农耕 + 商道 + 墨学 + 阴阳
    ['N041', 'S041', 'M041', 'Y041'],
    ['N041', 'S041', 'M041', 'Y042'],
    ['N041', 'S041', 'M042', 'Y041'],
    ['N041', 'S041', 'M042', 'Y042'],
    ['N041', 'S042', 'M041', 'Y041'],
    ['N041', 'S042', 'M041', 'Y042'],
    ['N041', 'S042', 'M042', 'Y041'],
    ['N041', 'S042', 'M042', 'Y042'],
    ['N042', 'S041', 'M041', 'Y041'],
    ['N042', 'S041', 'M041', 'Y042'],
    ['N042', 'S041', 'M042', 'Y041'],
    ['N042', 'S041', 'M042', 'Y042'],
    ['N042', 'S042', 'M041', 'Y041'],
    ['N042', 'S042', 'M041', 'Y042'],
    ['N042', 'S042', 'M042', 'Y041'],
    ['N042', 'S042', 'M042', 'Y042'],
    // 兵法 + 农耕 + 墨学 + 阴阳
    ['B041', 'N041', 'M041', 'Y041'],
    ['B041', 'N041', 'M041', 'Y042'],
    ['B041', 'N041', 'M042', 'Y041'],
    ['B041', 'N041', 'M042', 'Y042'],
    ['B041', 'N042', 'M041', 'Y041'],
    ['B041', 'N042', 'M041', 'Y042'],
    ['B041', 'N042', 'M042', 'Y041'],
    ['B041', 'N042', 'M042', 'Y042'],
    ['B042', 'N041', 'M041', 'Y041'],
    ['B042', 'N041', 'M041', 'Y042'],
    ['B042', 'N041', 'M042', 'Y041'],
    ['B042', 'N041', 'M042', 'Y042'],
    ['B042', 'N042', 'M041', 'Y041'],
    ['B042', 'N042', 'M041', 'Y042'],
    ['B042', 'N042', 'M042', 'Y041'],
    ['B042', 'N042', 'M042', 'Y042'],
    // 兵法 + 商道 + 墨学 + 阴阳
    ['B041', 'S041', 'M041', 'Y041'],
    ['B041', 'S041', 'M041', 'Y042'],
    ['B041', 'S041', 'M042', 'Y041'],
    ['B041', 'S041', 'M042', 'Y042'],
    ['B041', 'S042', 'M041', 'Y041'],
    ['B041', 'S042', 'M041', 'Y042'],
    ['B041', 'S042', 'M042', 'Y041'],
    ['B041', 'S042', 'M042', 'Y042'],
    ['B042', 'S041', 'M041', 'Y041'],
    ['B042', 'S041', 'M041', 'Y042'],
    ['B042', 'S041', 'M042', 'Y041'],
    ['B042', 'S041', 'M042', 'Y042'],
    ['B042', 'S042', 'M041', 'Y041'],
    ['B042', 'S042', 'M041', 'Y042'],
    ['B042', 'S042', 'M042', 'Y041'],
    ['B042', 'S042', 'M042', 'Y042'],
    // 百工 + 农耕 + 墨学 + 阴阳
    ['G041', 'N041', 'M041', 'Y041'],
    ['G041', 'N041', 'M041', 'Y042'],
    ['G041', 'N041', 'M042', 'Y041'],
    ['G041', 'N041', 'M042', 'Y042'],
    ['G041', 'N042', 'M041', 'Y041'],
    ['G041', 'N042', 'M041', 'Y042'],
    ['G041', 'N042', 'M042', 'Y041'],
    ['G041', 'N042', 'M042', 'Y042'],
    ['G042', 'N041', 'M041', 'Y041'],
    ['G042', 'N041', 'M041', 'Y042'],
    ['G042', 'N041', 'M042', 'Y041'],
    ['G042', 'N041', 'M042', 'Y042'],
    ['G042', 'N042', 'M041', 'Y041'],
    ['G042', 'N042', 'M041', 'Y042'],
    ['G042', 'N042', 'M042', 'Y041'],
    ['G042', 'N042', 'M042', 'Y042'],
    // 百工 + 商道 + 墨学 + 阴阳
    ['G041', 'S041', 'M041', 'Y041'],
    ['G041', 'S041', 'M041', 'Y042'],
    ['G041', 'S041', 'M042', 'Y041'],
    ['G041', 'S041', 'M042', 'Y042'],
    ['G041', 'S042', 'M041', 'Y041'],
    ['G041', 'S042', 'M041', 'Y042'],
    ['G041', 'S042', 'M042', 'Y041'],
    ['G041', 'S042', 'M042', 'Y042'],
    ['G042', 'S041', 'M041', 'Y041'],
    ['G042', 'S041', 'M041', 'Y042'],
    ['G042', 'S041', 'M042', 'Y041'],
    ['G042', 'S041', 'M042', 'Y042'],
    ['G042', 'S042', 'M041', 'Y041'],
    ['G042', 'S042', 'M041', 'Y042'],
    ['G042', 'S042', 'M042', 'Y041'],
    ['G042', 'S042', 'M042', 'Y042'],
  ],
  effects: {
    bonuses: {
      attackBonus: 1.3,
      defenseBonus: 1.3,
      speedBonus: 1.2,
      incomeBonus: 1.5,
      morale: 1.5,
    },
    special: {
      mandateOfHeaven: true,
    },
  },
  position: { x: 50, y: 95 },
  nodeShape: 'dragon',
  icon: '🐲',
  quote: '受命于天，既寿永昌',
};

// Helper to get ultimate tech prerequisites descriptions
export function getUltimatePrereqDescriptions(): string[] {
  return [
    '需要研究任意4个第五层科技',
    '兵法/百工/农耕/商道/墨学/阴阳 任选四个分支的终极科技',
  ];
}
